import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-16 text-xs md:text-sm" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-17">
          <div data-id="element-18">
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider" data-id="element-19">
              References
            </h4>
            <ul className="space-y-3" data-id="element-20">
              <li data-id="element-21">
                [1] ESVS 2022 Clinical Practice Guidelines (Europe) — Endorses
                venoactive drugs.
              </li>
              <li data-id="element-22">
                [2] AUA/SUFU Guideline (2024) — Nocturia often bladder/sleep
                related.
              </li>
              <li data-id="element-23">
                [3] Cochrane/Systematic Reviews — Horse Chestnut reduces venous
                insufficiency.
              </li>
              <li data-id="element-24">[4] JAMA 2011 — Saw Palmetto no better than placebo.</li>
              <li data-id="element-25">[5] Venous compression reduces nocturnal fluid shifts.</li>
            </ul>
          </div>
          <div data-id="element-26">
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider" data-id="element-27">
              Contact
            </h4>
            <p className="mb-4" data-id="element-28">
              Need help? Our customer support team is here for you at{' '}
              <a href="mailto:finn@arella.store" className="text-emerald-400 hover:underline" data-id="element-29">
                finn@arella.store
              </a>
            </p>
            <div className="border-t border-slate-800 pt-4 mt-8" data-id="element-30">
              <p className="mb-4 italic opacity-70" data-id="element-31">
                *These statements have not been evaluated by the Food and Drug
                Administration. This product is not intended to diagnose, treat,
                cure, or prevent any disease, including prostate cancer.
              </p>
              <p className="opacity-70" data-id="element-32">
                Individual results may vary. Always consult your healthcare
                provider before starting any new supplement.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-33">
          <p data-id="element-34">© 2025 Arella. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-35">
            <span className="cursor-pointer hover:text-white" data-id="element-36">
              Privacy Policy
            </span>
            <span className="cursor-pointer hover:text-white" data-id="element-37">
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>;
}